var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('blank-section',{attrs:{"empty-info":"404"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }